import config from "config/index.json";
import React from "react";
import Logo from "images/LOGO.svg";
import "./style.scss";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-logo" style={{backgroundImage: `url(${Logo})`}}/>
      <div className="footer-contacts">
        <h3>Связаться с нами</h3>
        <div>
          <span>
            Телефон:{" "}
            <a href={`tel:${config.telephone}`}>{config.telephoneVisible}</a>
          </span>
        </div>
        <div>
          <span>
            Почта:{" "}
            <a href={`mailto:${config.email}`}>{config.email}</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
